import { useEffect, useRef } from "react";
import site, { withBase } from "../../siteInfo";
import Reveal from "../../motion/Reveal";
import { gsap, prefersReducedMotion } from "../../motion/gsap";

const Doctors = () => {
  const frame = useRef(null);

  useEffect(() => {
    const el = frame.current;
    if (!el || prefersReducedMotion()) return undefined;

    const tween = gsap.fromTo(
      el.querySelector("img"),
      { scale: 1.08 },
      {
        scale: 1,
        ease: "none",
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          end: "bottom 20%",
          scrub: true,
        },
      }
    );

    return () => tween.scrollTrigger?.kill();
  }, []);

  return (
    <section className="section" id="doctors">
      <div className="wrap">
        <Reveal className="section-head">
          <p className="kicker">
            <span>03</span> Clinicians
          </p>
          <h2>One published visiting consultant.</h2>
          <p>
            Day-to-day OPD is run by the hospital’s duty clinicians. One visiting
            consultant is on the trust’s own notice. Call the same morning, because
            who is sitting can change.
          </p>
        </Reveal>
        <article className="doctor">
          <div className="doctor-photo" ref={frame}>
            <img
              src={withBase("/images/campus/consultant-notice.jpg")}
              alt="Published notice for Dr Arun Chowdary Kotaru at Rao Lokram Charitable Trust Hospital"
            />
          </div>
          <Reveal className="doctor-copy" delay={0.08}>
            <span className="tag">Sunday respiratory OPD</span>
            <h3>Dr Arun Chowdary Kotaru</h3>
            <p>
              MBBS, MD (Pulmonary, Critical Care and Sleep Medicine), DNB (Respiratory Medicine),
              European Respiratory Diploma (Madrid). Consultant in respiratory and sleep medicine.
            </p>
            <p>
              The trust’s notice lists him at this hospital on Sunday,{" "}
              {site.sundayOpd.replace("Sunday respiratory OPD ", "")}. For chest illness,
              a cough that stays, or sleep and snoring questions on other days, call{" "}
              <a href={`tel:${site.phoneTel}`}>{site.phoneDisplay}</a> or{" "}
              <a href={`tel:${site.phoneAltTel}`}>{site.phoneAltDisplay}</a> and ask who is available.
            </p>
            <p>
              We do not invent a roster of specialists the hospital has not published.
              If you need a named doctor, confirm on the phone the same morning.
            </p>
          </Reveal>
        </article>
      </div>
    </section>
  );
};

export default Doctors;
